import { Pipe, PipeTransform } from '@angular/core';
// Importación de Angular Fire 2
import { AngularFirestore } from 'angularfire2/firestore';
@Pipe({
  name: 'obtenerPropiedadConfirmacion'
})
export class ObtenerPropiedadConfirmacion implements PipeTransform {
    constructor(public afs: AngularFirestore) { }
  transform(id: any, propiedad:any): any {
        if(id)
            return this.afs.collection('confirmaciones').doc(id).valueChanges().take(1).map(confirmacion => confirmacion[propiedad]);
            
  }

}



// WEBPACK FOOTER //
// E:/Github/trosten/trosten-web-app/src/app/shared/pipes/obtener-propiedad-confirmacion.pipe.ts